import forest from "../assets/music/forest.mp3";
import lorn from "../assets/music/lorn.mp3";
import makeThemCryCanvas from "../assets/images/spotify/make-them-cry-canvas.jpg";
import related1 from "../assets/images/spotify/related-1.jpg";
import related2 from "../assets/images/spotify/related-2.jpg";

// What plays on the site, in Spotify and everywhere Now Playing shows it. Two lists ("contexts", as
// Spotify calls what a song plays from):
// - ICEMAN, the album open in Sylvester's Spotify: each track plays its 30-second preview, streamed
//   from Apple's iTunes previews. Plays, saved marks and music videos are from his screenshots.
// - Liked Songs: the two full songs the site has always played.
// A track has `artists`, its full `duration` in seconds, and the audio it plays (`src`). The first
// ICEMAN track also has what Spotify shows beside it: its Canvas, lyrics preview, related videos
// and credits.

const icemanArt = (size) =>
  `https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/7f/39/61/7f396123-be56-bc11-eaab-976441808e58/26UMGIM63622.rgb.jpg/${size}x${size}bb.jpg`;

export const ICEMAN = {
  id: "iceman",
  name: "ICEMAN",
  kind: "Album",
  artist: "Drake",
  year: 2026,
  length: "18 songs, 1 hr 8 min",
  released: "May 15, 2026",
  // About the artist, as Spotify showed it beside the album (the bio cut short where Spotify cuts it).
  about: {
    name: "Drake",
    listeners: "94,697,431",
    bio: "Canadian rapper and vocalist Drake has retained a bigger-than-life commercial presence shortly after he hit the scene in 2006, with both his own chart-topping",
  },
  copyright: [
    "© 2026 OVO, under exclusive license to Republic Records, a division of UMG Recordings, Inc.",
    "℗ 2026 OVO, under exclusive license to Republic Records, a division of UMG Recordings, Inc.",
  ],
  image: icemanArt(300),
  cover: icemanArt(640),
  color: "#412830",
  tracks: [
    {
      title: "Make Them Cry",
      artists: ["Drake"],
      video: false,
      plays: 79889245,
      saved: true,
      duration: 307,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/17/6c/29/176c29b4-2bfc-e79a-8e9e-a066d8928f8c/mzaf_1568051961098312212.plus.aac.p.m4a",
      canvas: makeThemCryCanvas,
      lyrics: ["Yeah", "Ice", "Yeah"],
      credits: [
        { name: "Drake", role: "Main Artist", follows: true },
        { name: "A. Graham", role: "Composer • Lyricist" },
      ],
      videos: [
        { image: related1, title: "Slap The City", artists: "Drake, Qendresa" },
        { image: related2, title: "Intro/Money To Blow", artists: "Drake" },
      ],
    },
    {
      title: "Dust",
      artists: ["Drake"],
      video: true,
      plays: 86776051,
      saved: true,
      duration: 189,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/e8/52/4a/e8524a16-44ff-0af8-bc24-298f528364b8/mzaf_538195082912149834.plus.aac.p.m4a",
    },
    {
      title: "Whisper My Name",
      artists: ["Drake"],
      video: true,
      plays: 159490379,
      saved: true,
      duration: 222,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/bf/b9/19/bfb919e7-71ce-7dcc-5153-f1d0a55393c7/mzaf_12434464070158687599.plus.aac.p.m4a",
    },
    {
      title: "Janice STFU",
      artists: ["Drake"],
      video: true,
      plays: 385470847,
      saved: true,
      duration: 237,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/c6/d7/d1/c6d7d1ec-84e6-ef8a-e02a-70d0ebb556be/mzaf_12941739828801829931.plus.aac.p.m4a",
    },
    {
      title: "Ran To Atlanta (feat. Future & Molly Santana)",
      artists: ["Drake", "Future", "Molly Santana"],
      video: true,
      plays: 146599773,
      saved: true,
      duration: 247,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/1e/ce/c2/1ecec239-a7f5-1cbe-e0b0-5d7ca2089779/mzaf_15720556376409377175.plus.aac.p.m4a",
    },
    {
      title: "Shabang",
      artists: ["Drake"],
      video: true,
      plays: 176792153,
      saved: true,
      duration: 188,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/f5/5e/57/f55e579b-4598-e298-f585-03dfd3b9951c/mzaf_17667839459904209421.plus.aac.p.m4a",
    },
    {
      title: "Make Them Pay",
      artists: ["Drake"],
      video: true,
      plays: 71349064,
      saved: false,
      duration: 301,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/09/ba/35/09ba359b-0e4b-17e7-3738-b59353f72841/mzaf_17941044474969674401.plus.aac.p.m4a",
    },
    {
      title: "Burning Bridges",
      artists: ["Drake"],
      video: true,
      plays: 75019758,
      saved: true,
      duration: 225,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/22/5a/a1/225aa1db-fdbe-9549-a9d1-741e253568ce/mzaf_6702884269955774001.plus.aac.p.m4a",
    },
    {
      title: "National Treasures",
      artists: ["Drake"],
      video: true,
      plays: 205952985,
      saved: true,
      duration: 200,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/16/04/63/160463ef-20fb-2e17-3b7b-1d916ea40fd2/mzaf_3195755801559110536.plus.aac.p.m4a",
    },
    {
      title: "B’s On The Table (feat. 21 Savage)",
      artists: ["Drake", "21 Savage"],
      video: true,
      plays: 98103186,
      saved: true,
      duration: 137,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/e7/cb/74/e7cb749b-2b9c-3b27-b45a-8e5da2493a49/mzaf_15494222518134088783.plus.aac.p.m4a",
    },
    {
      title: "What Did I Miss?",
      artists: ["Drake"],
      video: false,
      plays: 298451576,
      saved: false,
      duration: 194,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/73/14/9f/73149f4c-df5d-64f1-201e-60084711bd37/mzaf_2371427905086694386.plus.aac.p.m4a",
    },
    {
      title: "Plot Twist",
      artists: ["Drake"],
      video: true,
      plays: 111523409,
      saved: true,
      duration: 195,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/74/06/99/740699a4-79d6-0adb-eedd-bc2bd11071ea/mzaf_16819222938053497617.plus.aac.p.m4a",
    },
    {
      title: "2 Hard 4 The Radio",
      artists: ["Drake"],
      video: true,
      plays: 108228780,
      saved: true,
      duration: 183,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/fd/7f/fa/fd7ffaf1-1790-1b8d-9ba2-840b1d001fac/mzaf_9744536527102695989.plus.aac.p.m4a",
    },
    {
      title: "Make Them Remember",
      artists: ["Drake"],
      video: true,
      plays: 46372656,
      saved: false,
      duration: 323,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/2e/00/f2/2e00f225-091d-79b8-1805-14f331afbfa9/mzaf_4480851462322820865.plus.aac.p.m4a",
    },
    {
      title: "Little Birdie",
      artists: ["Drake"],
      video: true,
      plays: 48544851,
      saved: false,
      duration: 176,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/1d/89/dc/1d89dcf3-b67c-1381-23f9-65b81d213648/mzaf_4925677266435083316.plus.aac.p.m4a",
    },
    {
      title: "Don’t Worry",
      artists: ["Drake"],
      video: true,
      plays: 60893577,
      saved: true,
      duration: 246,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/30/ec/ea/30ecead0-dc93-6970-5995-c682a839baf9/mzaf_14096253829408091962.plus.aac.p.m4a",
    },
    {
      title: "Firm Friends",
      artists: ["Drake"],
      video: false,
      plays: 39236623,
      saved: true,
      duration: 302,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/8d/7e/03/8d7e033a-3b07-7ad3-4749-a4d3ed6c9efa/mzaf_8511095112511377446.plus.aac.p.m4a",
    },
    {
      title: "Make Them Know",
      artists: ["Drake"],
      video: true,
      plays: 62083085,
      saved: true,
      duration: 248,
      src: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/3c/40/9f/3c409fbc-89e3-2347-a778-7fb01f49f35b/mzaf_6246611213849400924.plus.aac.p.m4a",
    },
  ].map((t) => ({ ...t, image: icemanArt(300), explicit: true })),
};

export const LIKED = {
  id: "liked",
  name: "Liked Songs",
  kind: "Playlist",
  owner: "Sylvester",
  color: "#5038a0",
  tracks: [
    {
      title: "Friend, You Will Never Learn",
      artists: ["Forest Swords"],
      duration: 492,
      src: forest,
      image: "https://f4.bcbits.com/img/a3887714731_16.jpg",
    },
    {
      title: "Acid Rain",
      artists: ["Lorn"],
      duration: 172,
      src: lorn,
      image: "https://f4.bcbits.com/img/a0919112757_16.jpg",
    },
  ],
};

export const CONTEXTS = { iceman: ICEMAN, liked: LIKED };
